import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAP2TGoFb0kwea4UElVrCAvSnsVnL7ArVQ",
  authDomain: "spontane-gog47y.firebaseapp.com",
  projectId: "spontane-gog47y",
  storageBucket: "spontane-gog47y.appspot.com",
  messagingSenderId: "469675949347",
  appId: "1:469675949347:web:21823d85d62004ab09a096"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app); 
export const auth = getAuth(app);

// Initialize Functions with region
export const functions = getFunctions(app, 'us-central1');

// Remove or comment out the emulator connection
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }